import axios from "axios";

const isProduction = process.env.NODE_ENV === "production";
const baseURL = isProduction
  ? "https://mzazilink.com/e-wallet/api/v1/ussd/web"
  : "http://localhost/backends/mzazipay/api/v1/ussd/web";

const axiosInstance = axios.create({
  baseURL,
});

export default axiosInstance;
